import { ApiService } from './ApiService';

class TrailService extends ApiService {
    findOne(id) {
        return this.Get(`/trails/${id}`);
    }

    create(payload) {
        return this.Post(`/trails`, payload);
    }

    update(id, payload) {
        return this.Put(`/trails/${id}`, payload);
    }
}

export default new TrailService();
